import { ARInvoice, UseInvoicesProps } from '@melio/ar-domain';
import { BadgeProps } from '@melio/penny';

export const Filter = {
  all: 'All',
  draft: 'Drafts',
  unpaid: 'Unpaid',
  paid: 'Paid',
  overdue: 'Overdue',
} as const;

export type Filter = keyof typeof Filter;

type Params = NonNullable<NonNullable<UseInvoicesProps['params']>['sort']>;
type GetParam<T extends keyof Params> = NonNullable<Params[T]>;

export type Order = GetParam<'order'>;
export type SortField = GetParam<'field'>;

export type SortParams = Params;

export type OnSort = (sort: SortField, order: Order) => void;

export type UseSortableInvoicesParams = {
  invoiceStatus?: Filter;
  searchTerm?: string;
  sort?: SortField;
  order?: Order;
  pageNumber?: number;
};

export type SetSortableInvoicesParams = (params: Partial<UseSortableInvoicesParams>) => void;

type DisplayStatusLabel = Record<ARInvoice['displayStatus'], string>;

export const DisplayStatusLabel: DisplayStatusLabel = {
  unsent: 'Unsent',
  draft: 'Draft',
  failed: 'Failed',
  inProgress: 'In Progress',
  notSeen: 'Not Seen',
  overdue: 'Overdue',
  paid: 'Paid',
  scheduled: 'Scheduled',
  seen: 'Seen',
  canceled: 'Canceled',
};

export const DisplayStatusLabelMap: Record<ARInvoice['displayStatus'], BadgeProps['status']> = {
  draft: 'neutral',
  failed: 'critical',
  inProgress: 'success',
  notSeen: 'informative',
  seen: 'informative',
  overdue: 'warning',
  paid: 'success',
  scheduled: 'success',
  unsent: 'warning',
  canceled: 'critical',
};
